module.exports = __webpack_public_path__ + "icons_10150.ttf";


//////////////////
// WEBPACK FOOTER
// ./fonts/icons.ttf
// module id = 46
// module chunks = 0